export const MOIS = [
    { 'nom': 'Janvier', 'valeur': 1}, { 'nom': 'Février', 'valeur': 2}, { 'nom': 'Mars', 'valeur': 3},
    { 'nom': 'Avril', 'valeur': 4}, { 'nom': 'Mai', 'valeur': 5}, { 'nom': 'Juin', 'valeur': 6},
    { 'nom': 'Juillet', 'valeur': 7}, { 'nom': 'Août', 'valeur': 8}, { 'nom': 'Septembre', 'valeur': 9},
    { 'nom': 'Octobre', 'valeur': 10}, { 'nom': 'Novembre', 'valeur': 11}, { 'nom': 'Décembre', 'valeur': 12},
];
